import { RouteObject } from 'react-router-dom';
import loadable from '@loadable/component';

import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

const Authorizations = loadable(() => import('@/pages/CRM/Authorizations')); // prettier-ignore
const PriorAuthorizations = loadable(
  () => import('@/pages/CRM/Screener/PalAuthorizations')
); // prettier-ignore
const ConcurrentReviews = loadable(
  () => import('@/pages/CRM/Screener/PalReauths')
); // prettier-ignore

export enum CRMAuthorizationsRoutes {
  CRMAuthorizations = '/crm/authorizations',
  CRMAuthorizationsPriorAuthorizations = '/crm/authorizations/prior-authorizations',
  CRMAuthorizationsConcurrentReviews = '/crm/authorizations/concurrent-reviews'
}

export const getCrmAuthorizationsRoutes = (): RouteObject[] => {
  if (!FeatureFlagService.isEnabled(ExacareFeature.CRM_SCREENER)) {
    return [];
  }

  return [
    {
      path: CRMAuthorizationsRoutes.CRMAuthorizations,
      element: <Authorizations />,
      children: [
        {
          path: CRMAuthorizationsRoutes.CRMAuthorizationsPriorAuthorizations,
          element: <PriorAuthorizations />
        },
        {
          path: CRMAuthorizationsRoutes.CRMAuthorizationsConcurrentReviews,
          element: <ConcurrentReviews />
        }
      ]
    }
  ];
};
